import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.uint8-array.set-from-base64.js";
import "core-js/modules/esnext.uint8-array.set-from-hex.js";
import "core-js/modules/esnext.uint8-array.to-base64.js";
import "core-js/modules/esnext.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
var ImageCompress = /*#__PURE__*/function () {
  function ImageCompress(file, fileSize) {
    var maxWH = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1920;
    _classCallCheck(this, ImageCompress);
    this.file = file;
    this.fileSize = fileSize;
    this.maxWH = maxWH; // 最大长宽
  }
  return _createClass(ImageCompress, [{
    key: "compress",
    value: function compress() {
      var _this = this;
      // 压缩
      var fileType = this.file.type;
      var fileSize = this.file.size / 1024;
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(_this.file);
        reader.onload = function () {
          var canvas = document.createElement('canvas');
          var img = document.createElement('img');
          img.src = reader.result;
          img.onload = function () {
            var ctx = canvas.getContext('2d');
            var _dWH = _this.dWH(img.width, img.height, _this.maxWH);
            canvas.width = _dWH.width;
            canvas.height = _dWH.height;

            // 清空后, 重写画布
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            var newImgData = canvas.toDataURL(fileType, 0.90);

            // 压缩宽高后的图像大小
            var newImgSize = _this.fileSizeKB(newImgData);
            if (newImgSize > _this.fileSize) {
              console.log('图片尺寸太大!' + fileSize + ' >> ' + newImgSize);
            }
            var blob = _this.dataURLtoBlob(newImgData, fileType);
            var nfile = new File([blob], _this.file.name);
            resolve(nfile);
          };
        };
      });
    }

    /**
     * 长宽等比缩小
     * 图像的一边(长或宽)为最大目标值
     */
  }, {
    key: "dWH",
    value: function dWH(srcW, srcH, dMax) {
      var defaults = {
        width: srcW,
        height: srcH
      };
      if (Math.max(srcW, srcH) > dMax) {
        if (srcW > srcH) {
          defaults.width = dMax;
          defaults.height = Math.round(srcH * (dMax / srcW));
          return defaults;
        } else {
          defaults.height = dMax;
          defaults.width = Math.round(srcW * (dMax / srcH));
          return defaults;
        }
      } else {
        return defaults;
      }
    }
  }, {
    key: "fileSizeKB",
    value: function fileSizeKB(dataURL) {
      var sizeKB = 0;
      sizeKB = Math.round(dataURL.split(',')[1].length * 3 / 4 / 1024);
      return sizeKB;
    }

    /**
     * 转为Blob
     */
  }, {
    key: "dataURLtoBlob",
    value: function dataURLtoBlob(dataURL, fileType) {
      var byteString = atob(dataURL.split(',')[1]);
      var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      if (fileType) {
        mimeString = fileType;
      }
      return new Blob([ab], {
        type: mimeString,
        lastModifiedDate: new Date()
      });
    }
  }]);
}();
export { ImageCompress as default };